import styled from "@emotion/styled";
import React from "react";
import {useStores} from "../../stores/useStores";
import { observer } from "mobx-react-lite";
import Button from "../Button";
import LoginModal from "./LoginModal";
import LoggedInAccountInfo from "./LoggedInAccountInfo";
import { useNavigate } from "react-router-dom";

interface IProps {}

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const Wallet: React.FC<IProps> = () => {
  const { accountStore } = useStores();
  const { address } = accountStore;
  const navigate = useNavigate();

  return (
    <Root>
      {address == null ? (
        <Button
          size="medium"
          onClick={() => accountStore.setWalletModalOpened(true)}
          fixed
        >
          Connect wallet
        </Button>
      ) : (
        <>
        <LoggedInAccountInfo />
          <div style={{alignItems: 'center', display: 'flex', marginLeft: '10px'}}>
            <Button size="medium" weight="normal" onClick={() => {
              navigate('/create');
            }}>Create</Button>
          </div>
        </>
      )}
      <LoginModal
        visible={accountStore.walletModalOpened}
        onLogin={(loginType) => accountStore.login(loginType)}
        onClose={() => accountStore.setWalletModalOpened(false)}
      />
    </Root>
  );
};
export default observer(Wallet);
